import isBlobUrl from './isBlobUrl';

/**
 * Safely revokes a blob URL if the provided string is a valid blob URL.
 * Does nothing if the value is null, undefined, or not a blob URL.
 *
 * @param url - The URL to check and potentially revoke
 * @returns true if a blob URL was revoked, false otherwise
 */
const revokeBlobUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;

  if (!isBlobUrl(url)) return false;
  URL.revokeObjectURL(url);
  return true;
};

export default revokeBlobUrl;
